import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Suspense } from 'react';
import LoadingCircle from './LoadingCircle';
import AuthContext from '../../context/auth/AuthContext';
import { AUTH_ROUTES } from './routePaths';

function PrivateRoute({ children }) {
  const { userInfo } = useContext(AuthContext);

  return (
    <Route
      render={() =>
        userInfo ? (
          <Suspense
            fallback={
              <LoadingCircle
                openState={true}
                text='Application is loading...'
              />
            }
          >
            {children}
          </Suspense>
        ) : (
          <Redirect to={AUTH_ROUTES.LOGIN} />
        )
      }
    />
  );
}

export default PrivateRoute;
